import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function DisplayPartnerRecruitment() {
  const navigate = useNavigate()
  const [token, setToken] = useState(localStorage.getItem('token'))
  useEffect(() => {
    const onStorage = () => setToken(localStorage.getItem('token'))
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])
  return (
    <div className="bg-bg-light text-text antialiased">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <header className="text-center mb-12">
          <h1 className="text-5xl font-extrabold text-primary mb-4">Become a Display Partner</h1>
          <p className="text-lg text-muted">Host a screen and showcase local events that keep your community in the know.</p>
        </header>

        <section className="space-y-8">
          <h2 className="text-2xl font-semibold text-primary">Why Join IRL Drop?</h2>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <li className="flex items-start">
              <span className="text-accent mr-3 text-2xl">✔️</span>
              <span>Effortless setup: run on any browser-equipped device</span>
            </li>
            <li className="flex items-start">
              <span className="text-accent mr-3 text-2xl">✔️</span>
              <span>Auto-updated content: fresh events every hour</span>
            </li>
            <li className="flex items-start">
              <span className="text-accent mr-3 text-2xl">✔️</span>
              <span>Zero cost: free for all participating partners</span>
            </li>
            <li className="flex items-start">
              <span className="text-accent mr-3 text-2xl">✔️</span>
              <span>Community spotlight: featured on our partner map</span>
            </li>
          </ul>
        </section>

        <section className="mt-12">
          <h2 className="text-2xl font-semibold text-primary mb-4">How It Works</h2>
          <ol className="list-decimal list-inside space-y-2 text-base text-text">
            <li>Complete the 1-minute application form</li>
            <li>Receive approval and setup instructions</li>
            <li>Display your custom event playlist in any browser</li>
            <li>Enjoy an active, community-driven display</li>
          </ol>
        </section>

        <section className="mt-16 text-center">
          {token ? (
            <button
              data-tour="schedule-install-button"
              onClick={() => navigate('/user-dashboard?install=true')}
              className="mb-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Schedule Installation
            </button>
          ) : (
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link
                to={
                  "/register?next=" +
                  encodeURIComponent('/user-dashboard?install=true') +
                  '&displayPartner=true'
                }
                className="inline-block bg-primary hover:bg-primary-hover text-white font-medium px-8 py-3 rounded-lg shadow-lg transition"
              >
                Register & Schedule
              </Link>
              <Link
                to={
                  "/login?next=" +
                  encodeURIComponent('/user-dashboard?install=true') +
                  '&displayPartner=true'
                }
                className="inline-block bg-accent hover:bg-accent-hover text-white font-medium px-8 py-3 rounded-lg shadow-lg transition"
              >
                Login & Schedule
              </Link>
            </div>
          )}
        </section>

        <footer className="mt-12 text-center text-sm text-muted">
          <p>
          Questions?{' '}
          <a
            href="/help#troubleshooting-support"
            className="underline text-accent hover:text-accent-hover"
          >
            Contact Support
          </a>{' '}
          or visit the{' '}
          <Link
            to="/help/display_partner_guide"
            className="underline text-accent hover:text-accent-hover"
          >
            Partner Guide
          </Link>.
          </p>
        </footer>
      </div>
    </div>
  )
}